import { Route, Routes } from 'react-router-dom'
import { RouteGuard } from './features/auth/RouteGuard'
import { CwsDirectPage } from './features/cwsdirect/Page'
import { MediaDetailsPage } from './features/media-details/Page'
import { MediaManagementPage } from './features/media-management/Page'
import { ProviderManagementPage } from './features/provider-management/Page'
import { SearchPage } from './features/search/Page'
import { PageLayout } from './layout/PageLayout'
import { BulkEditPage } from './layout/pages/bulkEdit/BulkEditPage'
import { NotFoundPage } from './layout/pages/errors/NotFoundPage'
import { OidcPage } from './layout/pages/OidcPage'
import { WhatsNewPage } from './layout/pages/WhatsNewPage'

export default function Routing() {
  return (
    <Routes>
      <Route element={<PageLayout lockedHeight />}>
        <Route path="search/*" element={<SearchPage />} />
      </Route>
      <Route element={<PageLayout />}>
        <Route path="MediaDetails/:id" element={<MediaDetailsPage />} />
        <Route path="WhatsNew" element={<WhatsNewPage />} />
        <Route element={<RouteGuard allowedRoles={['admin', 'provider']} />}>
          <Route path="mediamanagement" element={<MediaManagementPage />} />
        </Route>
        <Route element={<RouteGuard allowedRoles={['admin']} />}>
          <Route
            path="providermanagement"
            element={<ProviderManagementPage />}
          />
        </Route>
        <Route path="response-oidc" element={<OidcPage />} />
        <Route path="bulk-edit" element={<BulkEditPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      <Route path="cwsdirect" element={<CwsDirectPage />} />
    </Routes>
  )
}
